import { Avatar } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"

import { WHY_NOTES } from "../_fixtures"

// The composed spread: a brief filling with contributions, set on navy
// as deliberate weight. This is the "Miro energy" rendered editorially,
// proofs landing on the desk, each bylined. The stagger is CSS-driven
// (tw-animate-css) so content is never gated on a JS reveal, and
// motion-reduce renders it static.
export function SpreadSection() {
  return (
    <section
      id="spread"
      aria-labelledby="spread-title"
      className="bg-brand-section scroll-mt-20 py-16 lg:py-24"
    >
      <div className="max-w-container mx-auto flex flex-col gap-10 px-4 lg:px-8">
        <header className="flex max-w-2xl flex-col gap-3">
          <h2
            id="spread-title"
            className="text-display-xs lg:text-display-sm text-primary_on-brand font-semibold text-balance"
          >
            A brief, filling
          </h2>
          <p className="text-secondary_on-brand text-md max-w-prose">
            Editorial structure from the curator, texture from the community.
            Watch the desk the way a visitor does: stories arriving in other
            people&rsquo;s hands, each one signed.
          </p>
        </header>

        <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_NOTES.map((note, index) => (
            <li
              key={note.id}
              className="bg-primary animate-in fade-in slide-in-from-bottom-4 fill-mode-backwards flex flex-col justify-between gap-4 rounded-xl p-5 duration-500 ease-out motion-reduce:animate-none"
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <p className="text-secondary text-sm">
                &ldquo;{note.note}&rdquo;
              </p>
              <div className="flex items-center gap-2.5">
                <Avatar size="xs" name={note.contributor} />
                <div className="flex min-w-0 flex-col">
                  <span className="text-primary text-xs font-semibold">
                    {note.contributor}
                  </span>
                  <span className="text-quaternary truncate text-xs">
                    {note.track} — {note.artist}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>

        <div className="flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center">
          <p className="text-tertiary_on-brand text-sm">
            7 of 10 slots filled · 23 suggestions · 6 contributors
          </p>
          <Button color="primary" size="lg">
            Add your story
          </Button>
        </div>
      </div>
    </section>
  )
}
